(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[470],{

/***/ 149:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/defi/make-money-on-BUSD-via-AlpacaFinance",
      function () {
        return __webpack_require__(4449);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ Markdown; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/remark-gfm/index.js + 27 modules
var remark_gfm = __webpack_require__(1346);
// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
;// CONCATENATED MODULE: ./src/Generic/models/Protocol.ts

var ProtocolSchema = lib.z["enum"]([
    "http",
    "https",
    "mailto",
    "tel",
    "tg"
]);
var _enum = ProtocolSchema.enum;
var http = _enum.http, https = _enum.https, mailto = _enum.mailto, tel = _enum.tel, tg = _enum.tg;

;// CONCATENATED MODULE: ./src/util/src/react-markdown.ts
var transformLinkUri = function(protocols) {
    return function(uri) {
        var url = (uri || "").trim();
        var first = url.charAt(0);
        if (first === "#" || first === "/") {
            return url;
        }
        var colon = url.indexOf(":");
        if (colon === -1) {
            return url;
        }
        var index = -1;
        while(++index < protocols.length){
            var protocol = protocols[index];
            if (colon === protocol.length && url.slice(0, protocol.length).toLowerCase() === protocol) {
                return url;
            }
        }
        index = url.indexOf("?");
        if (index !== -1 && colon > index) {
            return url;
        }
        index = url.indexOf("#");
        if (index !== -1 && colon > index) {
            return url;
        }
        // eslint-disable-next-line no-script-url
        return "javascript:void(0)";
    };
};

// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js + 111 modules
var react_markdown = __webpack_require__(6513);
;// CONCATENATED MODULE: ./components/Markdown.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





function Markdown(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, _objectSpread({
        linkTarget: "_blank",
        remarkPlugins: [
            remark_gfm/* default */.Z
        ],
        transformLinkUri: transformLinkUri(ProtocolSchema.options)
    }, props, {
        children: props.children
    }));
}


/***/ }),

/***/ 4449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ MakeMoneyOnBUSDViaAlpacaFinance; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./styles/layout.module.css
var layout_module = __webpack_require__(7272);
var layout_module_default = /*#__PURE__*/__webpack_require__.n(layout_module);
// EXTERNAL MODULE: ./styles/guides.module.css
var guides_module = __webpack_require__(1775);
var guides_module_default = /*#__PURE__*/__webpack_require__.n(guides_module);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(682);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 37 modules
var esm = __webpack_require__(3562);
// EXTERNAL MODULE: ./node_modules/random/dist/esm/index.esm.js + 19 modules
var index_esm = __webpack_require__(6867);
;// CONCATENATED MODULE: ./src/util/src/sampler.ts
function getSampler(random) {
    return function(array) {
        var index = random.int(0, array.length - 1);
        return array.length ? array[index] : undefined;
    };
}

// EXTERNAL MODULE: ./src/util/src/i18next.ts
var i18next = __webpack_require__(4873);
// EXTERNAL MODULE: ./components/Markdown.tsx + 2 modules
var Markdown = __webpack_require__(7331);
// EXTERNAL MODULE: ./src/util/src/string.ts
var string = __webpack_require__(146);
// EXTERNAL MODULE: ./src/Generic/models/UrlPattern/replaceUrlPattern.ts
var replaceUrlPattern = __webpack_require__(9978);
;// CONCATENATED MODULE: ./src/Wikifacts/getReferralUrl.ts

var ensureReferralUrl = function(systems) {
    return function(sampler, system, reflinks) {};
};
var getReferralUrl = function(sampler, system, reflinks) {
    var reflink = getReflink(sampler, system, reflinks);
    var code = reflink ? reflink.code : "";
    return (0,replaceUrlPattern/* replaceUrlPattern */.C)(system.referralUrlPattern, {
        code: code
    });
};
function getReflink(sampler, system, $reflinks) {
    var reflinks = $reflinks.filter(function(r) {
        return r.system.id === system.id;
    });
    return sampler(reflinks);
}

// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
// EXTERNAL MODULE: ./src/util/src/zod.ts + 1 modules
var zod = __webpack_require__(6338);
// EXTERNAL MODULE: ./src/Generic/models/Id.ts
var Id = __webpack_require__(7469);
// EXTERNAL MODULE: ./src/Generic/models/UrlPattern.ts
var UrlPattern = __webpack_require__(9786);
;// CONCATENATED MODULE: ./src/ReferralSystem/models/ReferralSystem.ts




var ReferralSystemSchema = lib.z.object({
    id: Id/* IdSchema */.KI,
    referralUrlPattern: UrlPattern/* UrlPatternSchema */.Ie
});
var ReferralSystemsSchema = lib.z.array(ReferralSystemSchema).superRefine((0,zod/* getDuplicatesRefinement */.$K)("ReferralSystem", parseReferralSystemUid));
var ReferralSystemUidSchema = ReferralSystemSchema.pick({
    id: true
});
function parseReferralSystem(system) {
    return ReferralSystemSchema.parse(system);
}
function parseReferralSystems(systems) {
    return ReferralSystemsSchema.parse(systems);
}
function parseReferralSystemUid(systemUid) {
    return ReferralSystemUidSchema.parse(systemUid);
}

;// CONCATENATED MODULE: ./src/Wikifacts/data/allReferralSystems.ts


var allReferralSystems = [];
var addReferralSystem = (0,zod/* getInserter */.VE)("ReferralSystem", ReferralSystemSchema, parseReferralSystemUid, allReferralSystems);
var findReferralSystem = (0,zod/* getFinder */.QC)(parseReferralSystemUid, allReferralSystems);
var Kuna = addReferralSystem({
    id: "Kuna",
    referralUrlPattern: "https://kuna.io?r={{code}}"
});
var Binance = addReferralSystem({
    id: "Binance",
    referralUrlPattern: "https://accounts.binance.com/register?ref={{code}}"
}) // export const BestchangeRu = addReferralSystem({
 //   id: 'BestchangeRu',
 //   referralUrlPattern: 'https://bestchange.ru/',
 // })
;

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./src/util/src/JSON.ts
var JSON = __webpack_require__(2313);
// EXTERNAL MODULE: ./node_modules/js-base64/base64.mjs
var base64 = __webpack_require__(2300);
;// CONCATENATED MODULE: ./components/context.ts
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};


function getRawContext(context) {
    switch(typeof context === "undefined" ? "undefined" : _typeof(context)){
        case "undefined":
            return undefined;
        case "object":
            return context[0];
        case "string":
            return context;
    }
}
function getContext(rawContext) {
    return (0,JSON/* safeParseJSON */.NX)((0,base64/* decode */.Jx)(rawContext));
} // const packedReflinks = fromReflinksToPackedReflinks(AlexanderLeginReflinks)
 // const context = packedReflinks
 // const contextJSONString = JSON.stringify(context)
 // const contextJSONStringBase64 = encode(contextJSONString)

;// CONCATENATED MODULE: ./src/ReferralSystem/models/ReferralCode.ts


var ReferralCodeSchema = lib.z.string().min(1);
var ReferralCodesSchema = lib.z.array(ReferralCodeSchema).superRefine((0,zod/* getDuplicatesRefinement */.$K)("ReferralCode", parseReferralCodeUid));
var ReferralCodeUidSchema = ReferralCodeSchema;
function parseReferralCode(referralCode) {
    return ReferralCodeSchema.parse(referralCode);
}
function parseReferralCodes(referralCodes) {
    return ReferralCodesSchema.parse(referralCodes);
}
function parseReferralCodeUid(referralCodeUid) {
    return ReferralCodeUidSchema.parse(referralCodeUid);
}

;// CONCATENATED MODULE: ./src/ReferralSystem/models/Reflink.ts




var ReflinkSchema = lib.z.object({
    system: ReferralSystemSchema,
    code: ReferralCodeSchema
});
var ReflinksSchema = lib.z.array(ReflinkSchema).superRefine((0,zod/* getDuplicatesRefinement */.$K)("Reflink", parseReflinkUid));
var ReflinkUidSchema = ReflinkSchema.pick({
    system: true
});
function parseReflink(link) {
    return ReflinkSchema.parse(link);
}
function parseReflinks(links) {
    return ReflinksSchema.parse(links);
}
function parseReflinkUid(linkUid) {
    return ReflinkUidSchema.parse(linkUid);
}

// EXTERNAL MODULE: ./src/util/src/ensure.ts
var ensure = __webpack_require__(6600);
;// CONCATENATED MODULE: ./src/ReferralSystem/models/PackedReflink.ts






var PackedReflinkSchema = lib.z.tuple([
    ReferralSystemSchema.shape.id,
    ReferralCodeSchema
]);
var PackedReflinksSchema = lib.z.array(PackedReflinkSchema);
function fromReflinksToPackedReflinks(reflinks) {
    return reflinks.map(function(r) {
        return [
            r.system.id,
            r.code
        ];
    });
}
function fromPackedReflinksToReflinks(packedReflinks) {
    return packedReflinks.map(function(r) {
        return parseReflink({
            system: (0,ensure/* ensure */.zx)(allReferralSystems.find(function(s) {
                return s.id === r[0];
            })),
            code: r[1]
        });
    });
}

// EXTERNAL MODULE: ./src/util/src/chai.ts
var chai = __webpack_require__(5469);
;// CONCATENATED MODULE: ./pages/defi/make-money-on-BUSD-via-AlpacaFinance.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

















var __N_SSG = true;
function MakeMoneyOnBUSDViaAlpacaFinance(props) {
    var reflinksFromProps = props.reflinks;
    var sampler = getSampler(index_esm/* default */.ZP);
    var router = (0,next_router.useRouter)();
    var rawContext = getRawContext(router.query.context);
    var context = rawContext ? getContext(rawContext) : [];
    var packedReflinksResult = PackedReflinksSchema.safeParse(context);
    var packedReflinksFromContext = packedReflinksResult.success ? packedReflinksResult.data : [];
    var reflinksFromContext = fromPackedReflinksToReflinks(packedReflinksFromContext);
    var reflinks = _toConsumableArray(reflinksFromProps).concat(_toConsumableArray(reflinksFromContext));
    var t = (0,esm/* useTranslation */.$G)(translationNamespaces).t;
    var tCurrencies = (0,i18next/* withNamespace */.Q)(t, "currencies");
    var tPages = (0,i18next/* withNamespace */.Q)(t, "pages");
    var tc = (0,i18next/* withNamespace */.Q)(t, "common");
    var title = tPages("defi.".concat(pageName, ".title"));
    var description = tPages("defi.".concat(pageName, ".description"));
    var currencySymbol = "BUSD";
    var risks = (0,string/* nail */.jQ)("\n    * \u0426\u0435\u043D\u0430 BUSD \u0443\u0439\u0434\u0435\u0442 \u043D\u0438\u0436\u0435 $1:\n      * \u0412\u0435\u0440\u043E\u044F\u0442\u043D\u043E\u0441\u0442\u044C: \u043D\u0438\u0437\u043A\u0430\u044F (BUSD \u0432\u044B\u043F\u0443\u0441\u043A\u0430\u0435\u0442\u0441\u044F \u0431\u0438\u0440\u0436\u0435\u0439 Binance, \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0435\u043D \u0437\u0430\u043F\u0430\u0441\u0430\u043C\u0438 USD \u043F\u043E\u0434 \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435\u043C Binance)\n    * \u041A\u0440\u0430\u0436\u0430 \u0432\u0430\u0448\u0435\u0433\u043E \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u043E\u0433\u043E \u043A\u043B\u044E\u0447\u0430:\n      * \u0412\u0435\u0440\u043E\u044F\u0442\u043D\u043E\u0441\u0442\u044C: \u043D\u0438\u0437\u043A\u0430\u044F (\u0435\u0441\u043B\u0438 \u0432\u044B \u0431\u0443\u0434\u0435\u0442\u0435 \u0442\u043E\u0447\u043D\u043E \u0441\u043B\u0435\u0434\u043E\u0432\u0430\u0442\u044C \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0438 \u043F\u043E \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044E \u043F\u0440\u0438\u0432\u0430\u0442\u043D\u043E\u0433\u043E \u043A\u043B\u044E\u0447\u0430)\n  ");
    var binanceReferralUrl = getReferralUrl(sampler, systemsRec.Binance, reflinks);
    (0,chai/* expect */.l)(binanceReferralUrl.endsWith("?ref=")).to.be.false;
    // `https://accounts.binance.com/en/register?ref=22330587`
    var rest = (0,string/* nail */.jQ)("\n  ### \u041E\u043F\u0440\u0435\u0434\u0435\u043B\u0438\u0442\u0435, \u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0432\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u0438\u043D\u0432\u0435\u0441\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C\n   * \u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u0434\u043B\u044F \u043D\u0430\u0447\u0430\u043B\u0430: 100 USD\n   \n  ### \u041F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 BUSD \u043D\u0430 \u0441\u0432\u043E\u0439 \u0430\u0434\u0440\u0435\u0441\n  \n  * [\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0443\u0439\u0442\u0435\u0441\u044C \u043D\u0430 Binance](".concat(binanceReferralUrl, ")\n  * [\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u043F\u043E\u043A\u0443\u043F\u043A\u0438 BUSD \u0437\u0430 RUB](https://p2p.binance.com/en/trade/buy/BUSD?fiat=RUB&payment=ALL)\n  * \u041A\u0443\u043F\u0438\u0442\u0435 BUSD\n    * \u0421\u0443\u043C\u043C\u0430: {\u0432\u044B\u0431\u0440\u0430\u043D\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u0438\u043D\u0432\u0435\u0441\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F}\n    * \u0410\u0434\u0440\u0435\u0441: {\u0432\u0430\u0448 \u0430\u0434\u0440\u0435\u0441}\n    * \u041D\u044E\u0430\u043D\u0441\u044B:\n      * \u041D\u0443\u0436\u043D\u043E \u043F\u0440\u043E\u0439\u0442\u0438 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044E\n      * \u041D\u0443\u0436\u043D\u043E \u0432\u043A\u043B\u044E\u0447\u0438\u0442\u044C 2-\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u0443\u044E \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044E\n  \n  ### \u041F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 BNB \u043D\u0430 \u0441\u0432\u043E\u0439 \u0430\u0434\u0440\u0435\u0441\n  \n  BNB - \u044D\u0442\u043E \u0442\u043E\u043A\u0435\u043D \u0431\u0438\u0440\u0436\u0438 Binance. \u041E\u043D \u043D\u0443\u0436\u0435\u043D \u0434\u043B\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0439 \u0432 \u0441\u0435\u0442\u0438 Binance Smart Chain.\n  \n  * [\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0443\u0439\u0442\u0435\u0441\u044C \u043D\u0430 Binance](").concat(binanceReferralUrl, ')\n  * [\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u043F\u043E\u043A\u0443\u043F\u043A\u0438 BNB \u0437\u0430 RUB](https://p2p.binance.com/en/trade/buy/BUSD?fiat=RUB&payment=ALL)\n  * \u041A\u0443\u043F\u0438\u0442\u0435 BNB\n    * \u0421\u0443\u043C\u043C\u0430: {\u0432\u044B\u0431\u0440\u0430\u043D\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u0438\u043D\u0432\u0435\u0441\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F}\n    * \u0410\u0434\u0440\u0435\u0441: {\u0432\u0430\u0448 \u0430\u0434\u0440\u0435\u0441}\n    * \u041D\u044E\u0430\u043D\u0441\u044B:\n      * \u041D\u0443\u0436\u043D\u043E \u043F\u0440\u043E\u0439\u0442\u0438 \u0432\u0435\u0440\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044E\n      * \u041D\u0443\u0436\u043D\u043E \u0432\u043A\u043B\u044E\u0447\u0438\u0442\u044C 2-\u0444\u0430\u043A\u0442\u043E\u0440\u043D\u0443\u044E \u0430\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044E\n\n  ### \u0418\u043D\u0432\u0435\u0441\u0442\u0438\u0440\u0443\u0439\u0442\u0435 BUSD \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E Alpaca Finance\n    * [\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u0437\u0430\u0439\u043C\u043E\u0432 Alpaca Finance](https://app.alpacafinance.org/lend)\n    * \u041D\u0430\u0439\u0434\u0438\u0442\u0435 \u0441\u0442\u0440\u043E\u043A\u0443 "BUSD"\n    * \u041D\u0430\u0436\u043C\u0438\u0442\u0435 "Deposit" \u0432 \u043D\u0430\u0439\u0434\u0435\u043D\u043D\u043E\u0439 \u0441\u0442\u0440\u043E\u043A\u0435\n    * \u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u0443\u043C\u043C\u0443: {\u0432\u044B\u0431\u0440\u0430\u043D\u043D\u0430\u044F \u0441\u0443\u043C\u043C\u0430 \u0438\u043D\u0432\u0435\u0441\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F}\n    * \u041D\u0430\u0436\u043C\u0438\u0442\u0435 "Approve"\n    * \u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044E\n    * \u041D\u0430\u0436\u043C\u0438\u0442\u0435 "Deposit"\n    * \u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u044E\n  \n  ## \u0418\u0442\u043E\u0433\n  \n  \u041F\u043E\u0437\u0434\u0440\u0430\u0432\u043B\u044F\u0435\u043C! \u0412\u0430\u0448 \u0434\u0435\u043F\u043E\u0437\u0438\u0442 BUSD \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D \u0438 \u0431\u0443\u0434\u0435\u0442 \u043F\u0440\u0438\u043D\u043E\u0441\u0438\u0442\u044C \u0435\u0436\u0435\u0434\u043D\u0435\u0432\u043D\u044B\u0439 \u0434\u043E\u0445\u043E\u0434. \u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u044B\u0432\u0435\u0441\u0442\u0438 \u0434\u0435\u043D\u044C\u0433\u0438 \u043D\u0430 \u0441\u0432\u043E\u0439 \u0430\u0434\u0440\u0435\u0441 \u0432 \u043B\u044E\u0431\u043E\u0439 \u043C\u043E\u043C\u0435\u043D\u0442.\n  '));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
        className: (layout_module_default()).main,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                className: (guides_module_default()).instructionHeader,
                children: [
                    "\uD83D\uDCB8 ",
                    title
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            t("dividendAvailableAt"),
                            ": ",
                            tc("onWithdrawal")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            t("depositAt"),
                            ": ",
                            tc("onDemand")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            t("withdrawAt"),
                            ": ",
                            tc("onDemand")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                        children: [
                            t("currency"),
                            ": ",
                            currencySymbol,
                            " (",
                            tCurrencies(currencySymbol),
                            ")"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (guides_module_default()).instructionSubheader,
                children: "\uD83E\uDDD0 \u0420\u0438\u0441\u043A\u0438"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                children: risks
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (guides_module_default()).instructionSubheader,
                children: "\uD83D\uDE0E \u0418\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044F"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                children: rest
            })
        ]
    });
};
// const ParamsSchema = z.object({
//   username: UsernameSchema,
// })
var systemsRec = {
    Binance: Binance
};
var pageName = "make-money-on-BUSD-via-AlpacaFinance";
var translationNamespaces = [
    pageName,
    "currencies",
    "pages",
    "common"
];


/***/ }),

/***/ 7469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KI": function() { return /* binding */ IdSchema; },
/* harmony export */   "hH": function() { return /* binding */ fromStringToId; }
/* harmony export */ });
/* unused harmony exports idAllowedSymbols, validateId, byId, getById, toSystemId */
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1604);
/* harmony import */ var _util_src_ensure__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6600);


var idAllowedSymbols = [
    "\\w",
    "\\d",
    "-",
    "_",
    ".",
    ":"
];
var idAllowedSymbolsEscapedString = idAllowedSymbols.join("");
var idRegExp = new RegExp("^[".concat(idAllowedSymbolsEscapedString, "]+$"));
var idReplaceUnwantedCharactersRegExp = new RegExp("[^".concat(idAllowedSymbolsEscapedString, "]"), "g");
var IdSchema = zod__WEBPACK_IMPORTED_MODULE_1__.z.string().min(1).regex(idRegExp);
function validateId(id) {
    return IdSchema.parse(id);
}
function byId(id) {
    return function(object) {
        return object.id === id;
    };
}
function getById(objects, id) {
    return ensure(objects.find(byId(id)), err("Cannot get object by id: ".concat(id)));
}
function fromStringToId(string) {
    return string.replace(idReplaceUnwantedCharactersRegExp, "");
}
function toSystemId(id) {
    return id.replace(/\s+/g, "_");
}


/***/ }),

/***/ 7117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ UrlSchema; }
/* harmony export */ });
/* unused harmony export validateUrl */
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1604);

var UrlSchema = zod__WEBPACK_IMPORTED_MODULE_0__.z.string().url().min(1);
function validateUrl(url) {
    return UrlSchema.parse(url);
}


/***/ }),

/***/ 9786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ie": function() { return /* binding */ UrlPatternSchema; },
/* harmony export */   "UV": function() { return /* binding */ substitutionRegExp; }
/* harmony export */ });
/* unused harmony exports UrlPatternsSchema, UrlPatternUidSchema, parseUrlPattern, parseUrlPatterns, parseUrlPatternUid */
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1604);
/* harmony import */ var src_util_src_zod__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6338);
/* harmony import */ var _Url__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7117);



var substitutionRegExp = /\{\{[^}]+\}\}/;
var UrlPatternSchema = _Url__WEBPACK_IMPORTED_MODULE_1__/* .UrlSchema.regex */ .z.regex(substitutionRegExp);
var UrlPatternsSchema = zod__WEBPACK_IMPORTED_MODULE_2__.z.array(UrlPatternSchema).superRefine((0,src_util_src_zod__WEBPACK_IMPORTED_MODULE_0__/* .getDuplicatesRefinement */ .$K)("UrlPattern", parseUrlPatternUid));
var UrlPatternUidSchema = _Url__WEBPACK_IMPORTED_MODULE_1__/* .UrlSchema */ .z;
function parseUrlPattern(urlPattern) {
    return UrlPatternSchema.parse(urlPattern);
}
function parseUrlPatterns(urlPatterns) {
    return UrlPatternsSchema.parse(urlPatterns);
}
function parseUrlPatternUid(urlPatternUid) {
    return UrlPatternUidSchema.parse(urlPatternUid);
}


/***/ }),

/***/ 9978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ replaceUrlPattern; }
/* harmony export */ });
/* harmony import */ var _UrlPattern__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9786);
/* harmony import */ var _util_src_chai__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5469);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


function replaceUrlPattern(pattern1, replacements) {
    var entries = Object.entries(replacements);
    var result = entries.reduce(function(pattern, param) {
        var _param = _slicedToArray(param, 2), search = _param[0], replace = _param[1];
        return pattern.replace("{{".concat(search, "}}"), replace);
    }, pattern1);
    (0,_util_src_chai__WEBPACK_IMPORTED_MODULE_1__/* .expect */ .l)(result).not.to.match(_UrlPattern__WEBPACK_IMPORTED_MODULE_0__/* .substitutionRegExp */ .UV) // should not contain unreplaced substitutions
    ;
    return result;
}


/***/ }),

/***/ 2313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NX": function() { return /* binding */ safeParseJSON; },
/* harmony export */   "Pz": function() { return /* binding */ stringify; }
/* harmony export */ });
/* unused harmony export toSerializableValue */
function safeParseJSON(input) {
    var $default = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    try {
        return JSON.parse(input);
    } catch (e) {
        return $default;
    }
}
function stringify(value) {
    return JSON.stringify(value, null, 2);
}
function toSerializableValue(value) {
    return value !== null && value !== void 0 ? value : null;
}


/***/ }),

/***/ 5469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ expect; }
/* harmony export */ });
/* harmony import */ var chai__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2757);
/* harmony import */ var chai_as_promised__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6495);
/* harmony import */ var chai_as_promised__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(chai_as_promised__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var chai_things__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4450);
/* harmony import */ var chai_things__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(chai_things__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var chai_subset__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2249);
/* harmony import */ var chai_subset__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(chai_subset__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var chai_bignumber__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6396);
/* harmony import */ var chai_bignumber__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(chai_bignumber__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4431);
/* harmony import */ var bignumber_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(bignumber_js__WEBPACK_IMPORTED_MODULE_5__);
// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="./chai-bignumber.d.ts" />






chai__WEBPACK_IMPORTED_MODULE_0__/* ["default"].use */ .ZP.use((chai_as_promised__WEBPACK_IMPORTED_MODULE_1___default()));
chai__WEBPACK_IMPORTED_MODULE_0__/* ["default"].use */ .ZP.use((chai_things__WEBPACK_IMPORTED_MODULE_2___default()));
chai__WEBPACK_IMPORTED_MODULE_0__/* ["default"].use */ .ZP.use((chai_subset__WEBPACK_IMPORTED_MODULE_3___default()));
chai__WEBPACK_IMPORTED_MODULE_0__/* ["default"].use */ .ZP.use(chai_bignumber__WEBPACK_IMPORTED_MODULE_4___default()((bignumber_js__WEBPACK_IMPORTED_MODULE_5___default())));
var expect = chai__WEBPACK_IMPORTED_MODULE_0__/* ["default"].expect */ .ZP.expect;


/***/ }),

/***/ 6600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "cn": function() { return /* binding */ err; },
/* harmony export */   "zx": function() { return /* binding */ ensure; }
/* harmony export */ });
/* unused harmony exports defaultCollectionFindThrowback, ensureStatic, checkAll, ensureFind, tb */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err1) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err1);
            }
            _next(undefined);
        });
    };
}


var defaultCollectionFindThrowback = function() {
    throw new Error("Can't find object in collection");
};
var err = function(message) {
    return function() {
        throw new Error(message);
    };
};
function ensure(object) {
    var throwback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultCollectionFindThrowback;
    if (object === null || object === undefined) {
        throw throwback();
    } else {
        return object;
    }
}
function ensureStatic(object, error) {
    if (object === null || object === undefined) {
        throw error !== null && error !== void 0 ? error : new Error("Can't find object in collection");
    } else {
        return object;
    }
}
function checkAll(objects) {
    if (!objects.every(identity)) {
        throw new Error("Some objects are falsy: \n\n".concat(JSON.stringify(objects)));
    } else {
        return objects;
    }
}
function ensureFind(collection, filter, error) {
    var object = collection.find(filter);
    if (object === null || object === undefined) {
        throw error !== null && error !== void 0 ? error : new Error("Can't find an object in a collection using filter: " + filter.toString());
    } else {
        return object;
    }
}
var tb = function(err2) {
    return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    return _ctx.abrupt("return", err2);
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
};


/***/ }),

/***/ 4873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ withNamespace; }
/* harmony export */ });
function withNamespace(t, ns) {
    return function(key) {
        return t(key, {
            ns: ns
        });
    };
}


/***/ }),

/***/ 146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "jQ": function() { return /* binding */ nail; }
/* harmony export */ });
/* unused harmony exports indent, replaceInFirstLine, getLines */
/**
 * Removes spaces at the beginning of each line (allows to indent multiline strings in code, then remove this indent via `nail()` call)
 * @see ./string.test.ts
 */ function nail(str) {
    var spacesAtStart = str.match(/^\n(\s+)/);
    if (spacesAtStart) {
        return str.replace(new RegExp("^[^\\S\r\n]{0,".concat(spacesAtStart[1].length, "}"), "gm"), "");
    } else {
        return str;
    }
}
function indent(count, str) {
    var padding = " ".repeat(count);
    return str.split("\n").map(function(s) {
        return padding + s;
    }).join("\n");
}
function replaceInFirstLine(haystack, needle, replacement) {
    var lines = haystack.split("\n");
    lines[0] = lines[0].replace(needle, replacement);
    return lines.join("\n");
}
function getLines(text) {
    return text.split("\n");
}


/***/ }),

/***/ 2927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RY": function() { return /* binding */ toUidFromSchema; },
/* harmony export */   "dP": function() { return /* binding */ byUid; }
/* harmony export */ });
/* unused harmony exports toUid, fromUid */
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3549);
/* harmony import */ var lodash_es__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6388);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function toUid(obj) {
    for(var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        keys[_key - 1] = arguments[_key];
    }
    return pick.apply(void 0, [
        obj
    ].concat(_toConsumableArray(keys)));
}
function toUidFromSchema(obj, schema) {
    return lodash_es__WEBPACK_IMPORTED_MODULE_0__/* ["default"].apply */ .Z.apply(void 0, [
        obj
    ].concat(_toConsumableArray(Object.keys(schema.shape))));
}
// export function toUid<T>(array: Array<T>): string {
//   return JSON.stringify(array)
// }
function fromUid(uid) {
    return JSON.parse(uid);
}
function byUid(getUid, holder) {
    var uid = getUid(holder);
    // console.log('uid', uid)
    return function($obj) {
        var $uid = getUid($obj);
        // console.log('$uid', $uid)
        return (0,lodash_es__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(uid, $uid);
    };
} // export function getCompositeUid<O extends Record<string, unknown>>(object: O, map: Record<keyof O, GetUid<unknown>>) {
 //   return JSON.stringify(Object.assign({}, object, { items: schedule.items.map(getScheduleItemUid) }))
 // }


/***/ }),

/***/ 6338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$K": function() { return /* binding */ getDuplicatesRefinement; },
  "QC": function() { return /* binding */ getFinder; },
  "VE": function() { return /* binding */ getInserter; },
  "oY": function() { return /* binding */ getName; }
});

// UNUSED EXPORTS: getDuplicateStats, getErrorReports, getGenericInserter, getMultiInserter, getUniqueCountStats, insert, mustIncludeAllOf, parse, parseWithSchema

// EXTERNAL MODULE: ./node_modules/zod/lib/index.mjs
var lib = __webpack_require__(1604);
// EXTERNAL MODULE: ./node_modules/lodash-es/isEqual.js + 43 modules
var isEqual = __webpack_require__(6388);
;// CONCATENATED MODULE: ./src/util/src/lodash.ts

function isEqualBy(a, b, getter) {
    return (0,isEqual/* default */.Z)(getter(a), getter(b));
}
function isSubset(set, subset) {
    return difference(set, subset).length === 0;
}
function mergeWithArrays(object, source1, source2) {
    return mergeWith(object, source1, source2, function(a, b) {
        if (isArray(a) && isArray(b)) {
            return b.concat(a);
        }
    });
}
var notInBy = function(getUid) {
    return function(elements) {
        return function(element) {
            return !elements.find(function(el) {
                return isEqualBy(el, element, getUid);
            });
        };
    };
};

// EXTERNAL MODULE: ./src/util/src/uid.ts
var uid = __webpack_require__(2927);
// EXTERNAL MODULE: ./src/util/src/ensure.ts
var ensure = __webpack_require__(6600);
;// CONCATENATED MODULE: ./src/util/src/zod.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





function getDuplicatesRefinement(name, getUniqueValue) {
    return function(objects, context) {
        var stats = getDuplicateStats(objects, getUniqueValue);
        stats.map(function(err1) {
            return context.addIssue({
                code: lib/* ZodIssueCode.custom */.NL.custom,
                params: err1,
                message: "Found ".concat(name, " duplicates: ").concat(JSON.stringify(err1))
            });
        });
    };
}
function getDuplicateStats(objects, getUniqueValue) {
    var stats = getUniqueCountStats(objects, getUniqueValue);
    return stats.filter(function(stat) {
        return stat.count > 1;
    });
}
function getUniqueCountStats(objects, getUniqueValue) {
    var stats1 = [];
    return objects.reduce(function(stats, value) {
        var uid = getUniqueValue(value);
        var index = stats.findIndex(function(s) {
            return (0,isEqual/* default */.Z)(s.uid, uid);
        });
        if (~index) {
            stats[index].count++;
        } else {
            stats.push({
                uid: uid,
                count: 1
            });
        }
        return stats;
    }, stats1);
}
var insert = function(name) {
    return function(schema) {
        return function(getUid) {
            return function(array) {
                return function(object) {
                    var $object = schema.parse(object);
                    var duplicate = array.find(function(o) {
                        return isEqualBy(o, $object, getUid);
                    });
                    if (duplicate) throw new Error("Duplicate ".concat(name, " found: ").concat(JSON.stringify(getUid(duplicate))));
                    array.push($object);
                    return $object;
                };
            };
        };
    };
};
function getGenericInserter(name, schema, getUid) {
    return insert(name)(schema)(getUid);
}
function getInserter(name, schema, getUid, array) {
    return insert(name)(schema)(getUid)(array);
}
function getMultiInserter(name, schema, getUid, array) {
    var inserter = insert(name)(schema)(getUid)(array);
    return function(objects) {
        return objects.map(inserter);
    };
}
function getFinder(getUid, array) {
    return function(uidHolder) {
        return array.find((0,uid/* byUid */.dP)(getUid, uidHolder));
    };
}
function parse(schema, input) {
    var result = schema.safeParse(input);
    if (result.success) {
        return result.data;
    } else {
        console.error("input", input);
        throw result.error;
    }
}
function getName(schema) {
    var description = (0,ensure/* ensure */.zx)(schema.description, (0,ensure/* err */.cn)("Cannot get schema name: ".concat(JSON.stringify(schema))));
    var ref = _slicedToArray(description.split(" "), 1), name = ref[0];
    return name;
}
var mustIncludeAllOf = function(required) {
    return function(elements) {
        return difference(required, elements).length === 0;
    };
};
function getErrorReports(results, schema) {
    var errors = results.reduce(function(reports, result, index) {
        if (result.success) {
            return reports;
        } else {
            var report = {
                index: index,
                error: result.error
            };
            return reports.concat([
                report
            ]);
        }
    }, []);
    return errors;
}
function parseWithSchema(objects, schema) {
    var results = objects.map(function(b) {
        return schema.safeParse(b);
    });
    return results.map(function(result, index) {
        if (result.success) {
            return result.data;
        } else {
            throw {
                index: index,
                error: result.error
            };
        }
    });
}


/***/ }),

/***/ 1775:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"instruction-header":"guides_instruction-header__FBi6Z","instruction-subheader":"guides_instruction-subheader__9Md2b"};

/***/ }),

/***/ 7272:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__5R52X","hero":"layout_hero__sdPiy","main":"layout_main__j5lor","footer":"layout_footer__a_vOy","title":"layout_title__zDlUa","subtitle":"layout_subtitle__Wt4qK","code":"layout_code__EMwy8","grid":"layout_grid__gVdal","card":"layout_card__dnilS","logo":"layout_logo__ZuUu7","list":"layout_list__0_v1E"};

/***/ }),

/***/ 5042:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [604,546,130,364,898,774,888,179], function() { return __webpack_exec__(149); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);